/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz';
import Component from '@reach/component-component';
import { Button, Tooltip, Icon } from 'kenobi-ui';
import Row from '../components/Row';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "tooltip"
    }}>{`Tooltip`}</h1>
    <h2 {...{
      "id": "details"
    }}>{`Details`}</h2>
    <h3 {...{
      "id": "tooltips-should-only-show-tips-or-provide-a-little-bit-of-further-information-they-should-not-hold-any-critical-information"
    }}>{`Tooltips should only show tips or provide a little bit of further information. They should not hold any critical information.`}</h3>
    <h3 {...{
      "id": "tooltip-does-not-take-any-children-to-make-developers-think-about-the-content-they-put-inside-the-tooltip-however-you-are-still-free-to-pass-in-any-react-components-as-the-content"
    }}><inlineCode parentName="h3">{`Tooltip`}</inlineCode>{` does not take any children to make developers think about the content they put inside the tooltip. However, you are still free to pass in any React components as the content.`}</h3>
    <h3 {...{
      "id": "if-you-want-to-show-more-meaningful-content-use-an-inline-dialog"
    }}>{`If you want to show more meaningful content use an `}<a parentName="h3" {...{
        "href": "/inline-dialog"
      }}>{`Inline Dialog`}</a></h3>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Playground __position={0} __code={'<Tooltip\n  placement=\"bottom\"\n  trigger={<Icon title=\"Edit\" icon=\"edit\" />}\n  content=\"Learn more about a feature\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Component,
      Button,
      Tooltip,
      Icon,
      Row
    }} mdxType="Playground">
  <Tooltip placement="bottom" trigger={<Icon title="Edit" icon="edit" mdxType="Icon" />} content="Learn more about a feature" mdxType="Tooltip" />
    </Playground>
    <h3 {...{
      "id": "by-default-the-tooltip-manages-it-own-isvisible-state"
    }}>{`By default the Tooltip manages it own `}<inlineCode parentName="h3">{`isVisible`}</inlineCode>{` state.`}</h3>
    <h3 {...{
      "id": "if-you-want-to-manually-show-tooltip-simply-pass-the-show-prop"
    }}>{`If you want to manually show `}<inlineCode parentName="h3">{`Tooltip`}</inlineCode>{`, simply pass the `}<inlineCode parentName="h3">{`show`}</inlineCode>{` prop.`}</h3>
    <h3 {...{
      "id": "component-is-not-part-of-kenobi"
    }}><strong parentName="h3">{`Component is not part of Kenobi`}</strong></h3>
    <Playground __position={1} __code={'<Component initialState={{ show: false }}>\n  {({ state, setState }) => (\n    <div style={{ display: \'flex\', alignItems: \'center\' }}>\n      <Button\n        onClick={() => setState({ show: !state.show })}\n        marginRight={16}\n      >\n        Toggle show\n      </Button>\n      <Tooltip\n        placement=\"right\"\n        show={state.show}\n        trigger={<Icon title=\"Edit\" icon=\"edit\" />}\n        content=\"Edit feature\"\n      />\n    </div>\n  )}\n</Component>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Component,
      Button,
      Tooltip,
      Icon,
      Row
    }} mdxType="Playground">
  <Component initialState={{
        show: false
      }} mdxType="Component">
    {({
          state,
          setState
        }) => <div style={{
          display: 'flex',
          alignItems: 'center'
        }}>
        <Button onClick={() => setState({
            show: !state.show
          })} marginRight={16} mdxType="Button">
          Toggle show
        </Button>
        <Tooltip placement="right" show={state.show} trigger={<Icon title="Edit" icon="edit" mdxType="Icon" />} content="Edit feature" mdxType="Tooltip" />
      </div>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "placing"
    }}>{`Placing`}</h2>
    <h3 {...{
      "id": "there-are-quite-a-few-options-for-placing-the-tooltip"
    }}>{`There are quite a few options for placing the Tooltip.`}</h3>
    <ul>
      <li parentName="ul">{`auto-start`}</li>
      <li parentName="ul">{`auto`}</li>
      <li parentName="ul">{`auto-end`}</li>
      <li parentName="ul">{`top-start`}</li>
      <li parentName="ul">{`top`}</li>
      <li parentName="ul">{`top-end`}</li>
      <li parentName="ul">{`right-start`}</li>
      <li parentName="ul">{`right`}</li>
      <li parentName="ul">{`right-end`}</li>
      <li parentName="ul">{`bottom-end`}</li>
      <li parentName="ul">{`bottom`}</li>
      <li parentName="ul">{`bottom-start`}</li>
      <li parentName="ul">{`left-end`}</li>
      <li parentName="ul">{`left`}</li>
      <li parentName="ul">{`left-start`}</li>
    </ul>
    <h3 {...{
      "id": "however-top-bottom-left-right-will-be-the-most-useful"
    }}>{`However, `}<inlineCode parentName="h3">{`top`}</inlineCode>{`, `}<inlineCode parentName="h3">{`bottom`}</inlineCode>{`, `}<inlineCode parentName="h3">{`left`}</inlineCode>{`, `}<inlineCode parentName="h3">{`right`}</inlineCode>{` will be the most useful.`}</h3>
    <Playground __position={2} __code={'<div style={{ display: \'flex\', justifyContent: \'space-between\' }}>\n  <Tooltip\n    placement=\"top\"\n    trigger={\n      <Button>\n        <Icon title=\"Top\" color=\"white\" icon=\"arrow-up\" />\n      </Button>\n    }\n    content=\"Top\"\n  />\n  <Tooltip\n    placement=\"left\"\n    trigger={\n      <Button>\n        <Icon title=\"left\" color=\"white\" icon=\"arrow-left\" />\n      </Button>\n    }\n    content=\"Left\"\n  />\n  <Tooltip\n    placement=\"right\"\n    trigger={\n      <Button>\n        <Icon title=\"right\" color=\"white\" icon=\"arrow-right\" />\n      </Button>\n    }\n    content=\"Right\"\n  />\n  <Tooltip\n    placement=\"bottom\"\n    trigger={\n      <Button>\n        <Icon title=\"bottom\" color=\"white\" icon=\"arrow-down\" />\n      </Button>\n    }\n    content=\"Bottom\"\n  />\n</div>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Component,
      Button,
      Tooltip,
      Icon,
      Row
    }} mdxType="Playground">
  <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
    <Tooltip placement="top" trigger={<Button mdxType="Button">
          <Icon title="Top" color="white" icon="arrow-up" mdxType="Icon" />
        </Button>} content="Top" mdxType="Tooltip" />
    <Tooltip placement="left" trigger={<Button mdxType="Button">
          <Icon title="left" color="white" icon="arrow-left" mdxType="Icon" />
        </Button>} content="Left" mdxType="Tooltip" />
    <Tooltip placement="right" trigger={<Button mdxType="Button">
          <Icon title="right" color="white" icon="arrow-right" mdxType="Icon" />
        </Button>} content="Right" mdxType="Tooltip" />
    <Tooltip placement="bottom" trigger={<Button mdxType="Button">
          <Icon title="bottom" color="white" icon="arrow-down" mdxType="Icon" />
        </Button>} content="Bottom" mdxType="Tooltip" />
  </div>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Tooltip} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  